export default __webpack_public_path__ + "static/media/check_mark.dba0bd9e.svg";